<script setup lang="ts">
import { computed } from 'vue'

import { iconBtnSize } from '@/constants/vSettings.constants'

const props = defineProps<{
  selected: boolean
  view?: boolean
}>()

const emit = defineEmits(['set', 'delete'])

const onChange = (selected: boolean | null) => {
  if (selected) {
    emit('set')
  } else {
    emit('delete')
  }
}

const title = computed(() => {
  if (props.view) return 'Удалить'

  return props.selected ? 'Снять выбор' : 'Выбрать'
})
</script>

<template>
  <div class="widget-record-action">
    <VIconBtn
      v-if="props.view"
      variant="text"
      :size="iconBtnSize"
      :title="title"
      icon="mdi-close"
      color="error"
      @click="emit('delete')"
    />
    <VCheckboxBtn
      v-else
      :model-value="props.selected"
      :title="title"
      :aria-label="title"
      color="primary"
      density="compact"
      @update:model-value="onChange"
    />
  </div>
</template>

<style scoped>
.widget-record-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}
</style>
